<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-28 12:16:51
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:48:37
 * @name: 调整部门
 * @Description: 调整部门
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\dialog\update-department.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog
    ref="addNeditDialog"
    title="调整部门"
    bar-title="部门选择"
    @close="close"
  >
    <template v-slot:form>
      <div class="line">
        <font class="label">部门:</font>
        <el-select
          class="input"
          v-model="department_id"
          placeholder="请选择部门"
        >
          <el-option
            v-for="item of departments"
            :key="item.id"
            :label="item.department_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="confirm">确定</el-button>
    </template>
  </addNeditDialog>
</template>

<script>
import { confirmation, debounceation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog";
export default {
  name: "updateDepartment",
  components: {
    addNeditDialog,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      department_id: "", //部门id
      departments: [], //部门列表
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     */
    open() {
      let { all, me } = this.mailList.getAllNodeNnow(); //获取所有部门及当前部门
      this.departments = all;
      this.department_id = me;
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.department_id = ""; //初始化部门id字段
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确定
     */
    @confirmation("确认调整部门?")
    confirm() {
      this.$emit("confirm", this.department_id);
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 400px;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
  }
  .input {
    flex: 1;
  }
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>